import React from 'react';
import ChartComponent from './ChartComponent';
import { BarChartData } from '../../types';
import { useTheme, useMediaQuery } from '@mui/material';

// Interface para as propriedades do componente
interface BarChartComponentProps {
  data: BarChartData;
  title: string;
  loading?: boolean;
  error?: string | null;
  height?: number | string;
  color?: string;
}

const BarChartComponent: React.FC<BarChartComponentProps> = ({
  data,
  title,
  loading = false,
  error = null,
  height = 350,
  color = '#4CAF50',
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Formatar os dados para o formato esperado pelo ChartComponent
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: data.label || title,
        data: data.values,
        backgroundColor: color,
        borderRadius: 5,
      },
    ],
  };

  // Opções do gráfico
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          boxWidth: isMobile ? 12 : 15,
          font: {
            size: isMobile ? 12 : 14
          }
        }
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += `R$ ${context.parsed.y.toLocaleString('pt-BR')}`;
            }
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value: any) {
            return `R$ ${value.toLocaleString('pt-BR')}`;
          },
          font: {
            size: isMobile ? 10 : 12
          }
        }
      },
      x: {
        ticks: {
          font: {
            size: isMobile ? 10 : 12
          }
        }
      }
    },
  };

  return (
    <ChartComponent
      chartType="bar"
      chartData={chartData}
      chartOptions={chartOptions}
      title={title}
      loading={loading}
      error={error}
      height={height}
    />
  );
};

export default BarChartComponent; 